<template>
    <div class="home-box">
      <PageTitle :title="pageTitle" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
            <GLTransactionAddingForm></GLTransactionAddingForm>
        </div>
      </v-row>
    </div>
</template>
  
  <script>
  import GLTransactionAddingForm from "@/components/GLTransaction/GLTransactionAddingForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "CreatePurchaseOrder",
    components: {
      PageTitle,
      GLTransactionAddingForm
    },

    data: function () {
      return {
        role: localStorage.getItem('role') || null,
        errors : null,
        loading : false,
        pageTitle : "Add Manual GL Transaction",
      };
    },
    computed: {
      ...mapGetters({
        vuexloading: "loading",
        profile: "profile",
        hasPermission: "hasPermission",
      }),

    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.$store.dispatch("settings/getCompanySettings");

    },
  
    methods: {

    },
  
    watch: {
    }
  };
  </script>
  